import React from "react";
import { Link } from 'react-router-dom';


export const Footer = () => {
    return (
        <>
        <footer className="footer-area footer-style-one-wrapper bg-color-footer bg_images tmp-section-gap">
            <div className="container">
                <div className="footer-main footer-style-one">
                    <div className="row g-5">
                        <div className="col-lg-5 col-md-6">
                            <div className="single-footer-wrapper border-right mr--20">
                                
                                <p className="description">Izrada Web Sajta Cena</p>
                                <p>Specijalizovani smo za modernu izradu web sajtova sa naglaskom na transparentnu cenu i merljive rezultate.</p>
                            </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                            <div className="single-footer-wrapper quick-link-wrap">
                                <h5 className="ft-title">Navigacija</h5>
                                <ul className="ft-link tmp-link-animation">
                                    <li>
                                        <Link to="/">Početna</Link>
                                    </li>
                                    <li>
                                        <Link to="/o-nama">O Nama</Link>
                                    </li>
                                    <li>
                                        <Link to="/servisi">Servisi</Link>
                                    </li>
                                    {/* <li>
                                        <Link to="/cene">Cene</Link>
                                    </li> */}
                                    <li>
                                        <Link to="/kontakt">Kontakt</Link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-lg-3 col-md-6">
                            <div className="single-footer-wrapper contact-wrap">
                                <h5 className="ft-title">Contact </h5>
                                <ul className="ft-link tmp-link-animation">
                                    <li><span className="ft-icon"><i className="fa-solid fa-envelope"></i></span>info@izrada-web-sajta-cena.com</li>
                                    {/* <li><span className="ft-icon"><i className="fa-solid fa-location-dot"></i></span>3891 Ranchview Dr. Richardson</li>
                                    <li><span className="ft-icon"><i className="fa-solid fa-phone"></i></span><a href="#">01245789321</a></li> */}
                                </ul>
                                <div className="logo">
                                    <Link to="/">
                                        <img src="assets/images/logo.png" loading="lazy" width={250} height={57} alt="Izrada web sajtova" />
                                    </Link>
                                </div>
                                {/* <div className="social-link footer">
                                    <a href="#"><i className="fa-brands fa-instagram"></i></a>
                                    <a href="#"><i className="fa-brands fa-linkedin-in"></i></a>
                                    <a href="#"><i className="fa-brands fa-twitter"></i></a>
                                    <a href="#"><i className="fa-brands fa-facebook-f"></i></a>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
        <div className="copyright-area-one">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="main-wrapper">
                            <p className="copy-right-para tmp-link-animation itu-copy"> © <a href="/">izrada-web-sajta-cena.com </a>
                                <script>
                                    document.write(new Date().getFullYear())
                                </script> | All Rights Reserved
                            </p>
                            {/* <ul className="tmp-link-animation">
                                <li><a href="#">Trams & Condition</a></li>
                                <li><a href="#">Privacy Policy</a></li>
                                <li><a href="contact.html">Contact Us</a></li>
                            </ul> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div className="scrollToTop" onClick={() => window.scrollTo({top: 0, behavior: 'smooth'}) } style={{display: "block"}}>
        <div className="arrowUp">
            <i className="fa-light fa-arrow-up"></i>
        </div>
        <div className="water" style={{transform: `translate(0px, 87%)`}} >
            <svg viewBox="0 0 560 20" className="water_wave water_wave_back">
                {/* <use xlink:href="#wave"></use> */}
            </svg>
            <svg viewBox="0 0 560 20" className="water_wave water_wave_front">
                {/* <use xlink:href="#wave"></use> */}
            </svg>
            <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 560 20" style={{display: "none"}}>
                <symbol id="wave">
                    <path d="M420,20c21.5-0.4,38.8-2.5,51.1-4.5c13.4-2.2,26.5-5.2,27.3-5.4C514,6.5,518,4.7,528.5,2.7c7.1-1.3,17.9-2.8,31.5-2.7c0,0,0,0,0,0v20H420z" fill="#"></path>
                    <path d="M420,20c-21.5-0.4-38.8-2.5-51.1-4.5c-13.4-2.2-26.5-5.2-27.3-5.4C326,6.5,322,4.7,311.5,2.7C304.3,1.4,293.6-0.1,280,0c0,0,0,0,0,0v20H420z" fill="#"></path>
                    <path d="M140,20c21.5-0.4,38.8-2.5,51.1-4.5c13.4-2.2,26.5-5.2,27.3-5.4C234,6.5,238,4.7,248.5,2.7c7.1-1.3,17.9-2.8,31.5-2.7c0,0,0,0,0,0v20H140z" fill="#"></path>
                    <path d="M140,20c-21.5-0.4-38.8-2.5-51.1-4.5c-13.4-2.2-26.5-5.2-27.3-5.4C46,6.5,42,4.7,31.5,2.7C24.3,1.4,13.6-0.1,0,0c0,0,0,0,0,0l0,20H140z" fill="#"></path>
                </symbol>
            </svg>

        </div>
    </div>
        </>
    );
};